import { FlexRow } from "../../../../../../../Common/Styles";

import styled from "styled-components";
import { FlexRowSpaced } from "../../../../../../../Common/Styles";

export const Container = styled.div<{ $isShow: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme, $isShow }) =>
    $isShow
      ? theme.spacing["spacing-4"].value
      : theme.spacing["spacing-none"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  background-color: rgba(177, 117, 253, 0.1);
`;
export const HeadingContainer = styled(FlexRowSpaced)`
  align-items: center;
`;
export const InputContainer = styled.div`
  background-color: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary"].value};
`;

export const Wrapper = styled(FlexRow)`
  align-items: center;
`;

export const AddTopicContainer = styled.div<{ height: number }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  max-height: ${({ height }) => height + "px"};
  overflow: hidden;
  transition: max-height 0.3s ease;
`;
